const SEL = ['[role="dialog"]', ...["lucky-wheel-modal", "level-up-modal", "jackpot-celebration", "redeem-celebration", "duel-celebration", "scratch-big-celebration",
  "lotto-jackpot-celebration", "contest-popup", "new-games-intro", "vip-celebration", "sky-celebration", "quest-popup", "quest-result-popup", "quest-hero-popup", "goldrain-results", "wa-newbie-hint", "logo-intro", "supporter-welcome", "halloween-popup", "invite-rules-popup", "invite-gate-dialog", "invite-welcome", "rebrand-popup"].map((t) => `[data-testid="${t}"]`)].join(",");
const queue = [];
let last = 0;

export const overlayOpen = () => !!document.querySelector(SEL);

export function whenFree(key, fn) {
  if (!queue.some((q) => q.key === key)) queue.push({ key, fn });
}

setInterval(() => {
  if (!queue.length || document.visibilityState !== "visible" || overlayOpen() || Date.now() - last < 1500) return;
  last = Date.now();
  queue.shift().fn();
}, 500);
